<section class="product" itemscope>
  <div [innerHTML]="structuredData"></div>

  <!----future-card-img-->
  <div
    class="product-image"
    [routerLink]="['/ad-details', advert.shortId]"
    itemprop="image">
    <img
      [src]="
        advert.images && advert.images.length
          ? advert.images[0]
          : '/assets/images/png/fallbackImage.png'
      "
      [alt]="
        advert?.name +
        ' - ' +
        (advert?.division?.name ?? '') +
        (advert?.area?.name ?? '') +
        (advert?.zone?.name ?? '') +
        ' - Product Image'
      "
      loading="lazy" />
  </div>

  <div class="details-div">
    <div class="product-body">
      <div>
        <header>
          <h4 itemprop="category">{{ categoryName }}</h4>
          <h2 itemprop="name">
            <a [routerLink]="['/ad-details', advert.shortId]" itemprop="url">
              {{ advert?.type?.name }} i
              {{
                advert?.zone?.name ??
                  advert?.area?.name ??
                  advert?.division?.name
              }}
              by {{ name }}
            </a>
          </h2>
        </header>
        <p class="shortDescription" itemprop="description">
          {{ advert.shortDescription }}
        </p>
      </div>
      <div class="location-div">
        <div class="bottom-align-text">
          <a [href]="'/ads?types=' + advert?.type?.slug"
            ><p>{{ 'FEATURE.ESCORT' | translate }}</p></a
          >
          <a [href]="'/ads?divisions=' + advert?.division?.slug"
            ><p>{{ advert?.division?.name }}</p></a
          >
        </div>
      </div>
    </div>

    <div class="btn-div">
      <div class="btn-link">
        <a [routerLink]="['/ad-details', advert.shortId]">
          {{ 'FEATURE.SEE_MORE' | translate }}
        </a>
      </div>

      <div class="icon-text">
        <p (click)="onAddToFavorite($event)" [ngClass]="{ active: isFavorite }">
          <i class="fa-solid fa-heart"></i>
          {{
            isFavorite
              ? ('FEATURE.REMOVE_FAVORITE' | translate)
              : ('FEATURE.ADD_TO_FAVORITE' | translate)
          }}
        </p>
        <p (click)="openComponentDialog(advert.shortId)">
          @if (advert) {
            <i class="fa-solid fa-search"></i>
          }
          {{ 'FEATURE.QUICK_VIEW' | translate }}
        </p>
      </div>
    </div>
  </div>
</section>
